module.exports = __webpack_public_path__ + "res/28-img_next.fd7abd6aff589ca0c372d2722949a31b.png";